import { getNumDaysInDayRange } from 'owa-calendar-surface-options-utils';
import { DateRangeType } from '@fluentui/date-time-utilities/lib/dateValues/dateValues';
import { getCalendarSurfaceStore } from 'owa-calendar-surface-surface-store';
import { getNumSurfaceViews } from './getNumSurfaceViews';

const DEFAULT_NUM_COLUMNS = 7;

export function getNumColumns() {
    const { dateRangeType, userOptions } = getCalendarSurfaceStore();

    if (dateRangeType === DateRangeType.Month) {
        return DEFAULT_NUM_COLUMNS;
    }

    const numSurfaceViews = getNumSurfaceViews();
    if (dateRangeType === DateRangeType.Week) {
        return DEFAULT_NUM_COLUMNS * numSurfaceViews;
    }
    if (dateRangeType === DateRangeType.WorkWeek) {
        const numWorkDays = userOptions.workDays ? userOptions.workDays.length : 5;
        return numWorkDays * numSurfaceViews;
    }
    if (dateRangeType === DateRangeType.Day) {
        const numDaysInDayRange = getNumDaysInDayRange();
        return numDaysInDayRange * numSurfaceViews;
    }
    return DEFAULT_NUM_COLUMNS;
}
